















import Vue, { PropOptions } from 'vue';

export default Vue.extend({
  name: 'CheckBoxList',
  components: {  },
  props: {
    divID: String, // 各リスト用のCSSを下に定義してdivIDを指定すると反映されます
    items: Array as PropOptions<any[]>,
    fields: Array as PropOptions<any[]>,
    filter: { type: [Object, String] }, // ObjectとStringの両方の型を許容
    filterFunction: Function,
  },
  data() {
    return {
      checkAll: false,
      autoCheck: false,
    };
  },
  watch: {
    // ユーザー一覧ヘッダのチェックボックス
    checkAll(isCheck: boolean) {
      if (!this.autoCheck) {
        for (const item of this.items) {
          item.checked = isCheck;
        }
        this.$emit('inputAll', isCheck);
      }
      this.autoCheck = false;
    },
  },
  computed: {
  },
  async mounted() {
  },
  methods: {
    onInputCheck(data: any, e: any) {
      this.$emit('input', data.item, e.target.checked);

      let count = 0;
      for (const item of this.items) {
        if (item.checked) {
          count++;
        }
      }

      if (this.items.length === count) {
        this.autoCheck = this.checkAll ? false : true; // 元と変わらなければautoCheckをfalseにする
        this.checkAll = true;
      } else {
        this.autoCheck = !this.checkAll ? false : true;
        this.checkAll = false;
      }
    },
  },
});
